import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { LoginService } from '../services/login.service';
import { LoadingService } from '../services/loading.service';

export const authenticatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(LoginService);
  const router = inject(Router);
  const loadingService = inject(LoadingService);

  loadingService.show();

  return authService.checkAccess().pipe(
    map(access => {
      loadingService.hide();
      if (!access) {
        router.navigate(['/login'], { state: { redirectedByGuard: true } });
        return false;
      }
      return true;
    }),
    catchError(() => {
      loadingService.hide();
      router.navigate(['/login'], { state: { redirectedByGuard: true } });
      return of(false);
    })
  );
};